// extracted by mini-css-extract-plugin
export var locationCard = "_e4-0";